// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__20Oe5","col":"Table_col__3RCfd","fulfillmentStatus":"Table_fulfillmentStatus__3PHXu","emailCol":"Table_emailCol__3wx3s"};